/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'

export default function Input(props) {
  const {
    name,
    label,
    sublabel,
    onChange,
    type = 'text',
    defaultValue = '',
    displayRequiredMark = true,
    required,
    customvalue,
    rows,
    placeholder,
    id,
    maxLength,
    wrapperclassname = '',
  } = props

  const [value, setValue] = useState(defaultValue)
  const [, setClicked] = useState(false)

  useEffect(() => {
    if (customvalue) {
      if (customvalue === value) return
      document.getElementById(id).defaultValue = maxLength ? customvalue.slice(0, maxLength) : customvalue
      setValue(customvalue || '')
    }
  }, [customvalue])

  const handleChange = (evt) => {
    if (onChange) onChange(evt.target.value)
    setValue(evt.target.value || '')
  }

  const fieldProps = {
    ...props,
  }

  if (type === 'textarea') {
    delete fieldProps.type

    // fieldProps.defaultValue = value
    fieldProps.rows = rows || 4
  }

  delete fieldProps.displayRequiredMark

  return (
    <div onClick={() => setClicked(true)} className={wrapperclassname}>
      {label ? (
        <label htmlFor={name}>
          {`${label}${displayRequiredMark && required ? '*' : ''}`}{' '}
          {sublabel && <span className="sublabel">{sublabel}</span>}
        </label>
      ) : (
        ''
      )}
      {type === 'textarea' ? (
        <textarea placeholder={placeholder ? placeholder : label} {...fieldProps} />
      ) : (
        <input
          {...fieldProps}
          className={`${fieldProps.className}`}
          placeholder={placeholder ? placeholder : label}
          onChange={handleChange}
        />
      )}
    </div>
  )
}
